import { pxToRem } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const FlagAvatar = styled.div `
  height: ${pxToRem(21)};
  width: ${pxToRem(21)};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  svg {
    path {
      height: ${pxToRem(28)};
    }
  }
`;
